import React, { FC, useCallback } from "react";
import { IDamsList, IStateOfKnowledge, dataEntry, IDataTest, ISocietalRisk, ISummaryControlMeasureAdequacy, ISummaryControlMeasureAssessment, ICostSummary, ISummaryCriticalHazards, ISummarySOK, ILikelihood, IHarmSummary } from "../../types/types";
import { Accordion, AccordionSummary, Grid, Paper, Tooltip, IconButton, colors } from "@material-ui/core";
import BarChart from "./bar";
import DamHeatMap from "./dam_heat_map";
import { ExpandMore } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import Map from "./map";
import PieChart from "./pie";
import { trafficLight } from "../../theme";
import SoKInfo from "./sok_infobar";
import NoDamInfo from "./no_dam";
import HeatMapTable from "./heat_map_table";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { CSVLink, CSVDownload } from "react-csv";
import SummaryLegend from "./summay_ledgend";
import SummaryPie from "./summary_pie";

import GetAppIcon from '@material-ui/icons/GetApp';
import NotesIcon from '@material-ui/icons/Notes';


import { toPng } from "html-to-image";
import downloadjs from "downloadjs";

const useStyles = makeStyles({

    grid: {
        display: 'grid',
        gridTemplateColumns: 'max-content repeat(11,1fr)',
        padding: '10px 5% 10px 5%',
        justifyContent: 'center',

    },

    heading1: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid grey',
        fontSize: '12px',
        fontWeight: 'bold',
        height: '50px',
        whiteSpace: 'nowrap',
        padding: '2px 2px',
    },

    heading2: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRight: '1px solid grey',
        borderBottom: '1px solid grey',
        gridRow: '2 / span 2',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    item: {
        display: 'flex',
        justifyContent: 'center',
        borderBottom: '1px solid lightgrey',
        alignItems: 'center',
        fontSize: '12px',
        padding: '0px 2px',



    },
    item2: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        width: '15px',
        height: '15px',
        margin: '2px 0px',
        '&:hover': {
            transform: 'scale(1.0)',
            boxShadow: '0px 0px 5px 0px black',

        }
    },
    title: {
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'center',
        borderRight: '1px solid grey',

        fontSize: '12px',
        padding: '0px 2px',

    },
    superscript: {
        gridColumn: '2 / span 5',
        textAlign: 'left',
        fontSize: '12px',
        marginTop: '5px'
    }


});

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 14,
    },
}))(Tooltip);



interface ISokProps {
    //stateOfKnowledge: IStateOfKnowledge[],
    sokSummary: ISummarySOK[],
    damList: IDamsList[],
    assessments_filtered: number[],
    likelihood: ILikelihood[],
    harm: IHarmSummary[]
    criticalHazards: ISummaryCriticalHazards[],
    controlMeasures: ISummaryControlMeasureAdequacy[],
    costAssessment: ICostSummary[],
    controlMeasureAssessments: ISummaryControlMeasureAssessment[]
    risk_assessments: ISocietalRisk[]
}


const Summary: FC<ISokProps> = ({ sokSummary, damList, assessments_filtered, risk_assessments, likelihood, harm, criticalHazards, controlMeasures, costAssessment, controlMeasureAssessments }) => {

    const classes = useStyles();

    // All the data is processed internally within the componant which does make for some double handling
    // but in all of the other plots the data for

    let dam_names_filtered: IDamsList[] = [];
    let sok_filtered: ISummarySOK[] = [];
    let harm_filtered: IHarmSummary[] = [];
    let likelihood_filtered: ILikelihood[] = [];
    let critical_hazards_filtered: ISummaryCriticalHazards[] = [];
    let control_measures_filtered: ISummaryControlMeasureAdequacy[] = [];
    let cost_assessment_filtered: ICostSummary[] = [];
    let control_measure_assessments_filtered: ISummaryControlMeasureAssessment[] = [];
    let risk_assessments_filtered: ISocietalRisk[] = [];


    let countData: any = []

    // filter all of the data for the selected dams
    const elements = assessments_filtered.map(id => {
        const filtered = damList.filter(s => s.id === id)
        filtered.forEach(element => dam_names_filtered.push(element))

        const filtered_sok = sokSummary.filter(s => s.assessment_project_id === id)
        filtered_sok.forEach(element => sok_filtered.push(element))

        const filtered_harm = harm.filter(s => s.assessment_project_id === id)
        filtered_harm.forEach(element => harm_filtered.push(element))

        const filtered_likelihood = likelihood.filter(s => s.assessment_project_id === id)
        filtered_likelihood.forEach(element => likelihood_filtered.push(element))

        const filtered_critical_hazards = criticalHazards.filter(s => s.assessment_project_id === id)
        filtered_critical_hazards.forEach(element => critical_hazards_filtered.push(element))

        const filtered_control_measures = controlMeasures.filter(s => s.assessment_project_id === id)
        filtered_control_measures.forEach(element => control_measures_filtered.push(element))

        const filtered_cost_assessment = costAssessment.filter(s => s.assessment_project_id === id)
        filtered_cost_assessment.forEach(element => cost_assessment_filtered.push(element))

        const filtered_control_measure_assessments = controlMeasureAssessments.filter(s => s.assessment_project_id === id)
        filtered_control_measure_assessments.forEach(element => control_measure_assessments_filtered.push(element))

        const filtered_risk_assessments = risk_assessments.filter(s => s.assessment_project_id === id)
        filtered_risk_assessments.forEach(element => risk_assessments_filtered.push(element))

    })

    const handleCaptureClick = useCallback(() => {

        const pricingTableElmt = document.querySelector<HTMLElement>('.sum-table')
        if (!pricingTableElmt) return;
        toPng(pricingTableElmt, { pixelRatio: 4, cacheBust: true })
            .then((dataUrl: any) => {
                downloadjs(dataUrl, 'Overall_summary.png');
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])



    const data = dam_names_filtered.map(dam => {

        let name = dam.dam.name

        // get the societal risk
        let risk = risk_assessments_filtered.filter(s => s.assessment_project_id === dam.id)


        // there is the potential for a dam to not have any data
        let societal_risk_value: any = 0
        if (risk.length > 0) {
            let societal_risk_value_number = risk[0].societal_risk_before
            // societal_risk_value = 
            societal_risk_value = societal_risk_value_number.toExponential(2)
        }


        // Process the data for the State of Knowledge

        let sok: ISummarySOK | number = sok_filtered.filter(s => s.assessment_project_id === dam.id)[0]
        sok ? sok = sok.adequacy.level : sok = 0


        // Processing the harm data

        let harm = harm_filtered.filter(s => s.assessment_project_id === dam.id)
        let harm_id = 0
        let categories: [string, number][] = [['Extreme', 4], ['High A', 3], ['High B', 3], ['High C', 3], ['Significant', 2], ['Low', 1], ['Very Low', 1]]

        harm.forEach(mode => {

            for (const element of categories) {
                if (mode.category.includes(element[0]) && element[1] > harm_id)
                    harm_id = element[1]
            }
        })


        // Processing the likelihood data

        let likelihood: ILikelihood | number = likelihood_filtered.filter(s => s.assessment_project_id === dam.id)[0]
        likelihood ? likelihood = likelihood.max_annual_failure_probability : likelihood = -1


        let likelihood_id = 0

        if (likelihood === -1) {
            likelihood_id = 0
        }
        else if (likelihood >= 0.001) {

            likelihood_id = 1
        }
        else if (likelihood <= 0.001 && likelihood >= 0.0001) {
            likelihood_id = 2
        }
        else if (likelihood <= 0.0001 && likelihood >= 0.00001) {
            likelihood_id = 3
        }
        else if (likelihood <= 0.00001) {
            likelihood_id = 4
        }


        // Process the critical hazards

        let critical_hazards = critical_hazards_filtered.filter(s => s.assessment_project_id === dam.id)



        // if they exist, get the worst case
        let critical_hazards_societal_id = 0
        let critical_hazards_individual_id = 0
        if (critical_hazards.length > 0) {
            let soc = critical_hazards.reduce((a, b) => {
                return a.societal_confidence_id > b.societal_confidence_id ? a : b
            })

            critical_hazards_societal_id = soc.societal_confidence_id


            let ind = critical_hazards.reduce((a, b) => {
                return a.individual_confidence_id > b.individual_confidence_id ? a : b
            })

            critical_hazards_individual_id = ind.individual_confidence_id
        }




        /// Improving the controls
        let control_measures = control_measures_filtered.filter(s => s.assessment_project_id === dam.id)

        // if the control measures exist, get the worst case
        let control_measures_id = 0
        if (control_measures.length > 0) {

            let levels = control_measures.map(element => {
                let level = 0
                if (element.improvement_adequacy !== null) {
                    level = element.improvement_adequacy.level
                }

                return level
            });

            let worst = levels.reduce((a, b) => {
                return a < b ? a : b

            })
            control_measures_id = worst

        }



        // Processing the cost assessment
        // as some control measures are always undefined, 
        let cost_assessment = cost_assessment_filtered.filter(s => s.assessment_project_id === dam.id)

        let cost_assessment_id = 0
        if (cost_assessment.length > 0) {

            // set level to 5 to be able to find the min value
            let levels = cost_assessment.map(element => {
                let level = 5
                if (element.cost_adequacy !== null) {
                    level = element.cost_adequacy.level
                }
                return level
            })

            let worst = levels.reduce((a, b) => {
                return a < b ? a : b
            })

            cost_assessment_id = worst
        }



        // Processing the control measure counts

        // get a list of all the control measures for this dam and filter them to ensure they are not null and are either considered or de minimus
        let control_measure_assessments: ISummaryControlMeasureAssessment[] = control_measure_assessments_filtered.filter(
            s => s.assessment_project_id === dam.id
                && (s.considered === true || s.de_minimis === true)
                && s.overall_assessment_id !== null)



        // in this list above, there are multiples of the same control measure tied to each individual critical hazard.
        // we need to get a list of the the control meausre ids with no duplicates
        const control_measure_ids: (number | undefined)[] = Array.from(new Set(control_measure_assessments.map(a => {

            if (a.considered === true || a.de_minimis === true) {
                return a.control_measure_id
            }
        })))

        // if any of the control measures are de minimus, we need to count them and remove them from the list
        let dm = 0
        let to_remove: (number | undefined)[] = []
        control_measure_ids.forEach(element => {
            let dm_count = control_measure_assessments.filter(s => s.control_measure_id === element && s.de_minimis === true).length
            if (dm_count > 0) {
                dm += 1
                to_remove.push(element)
            }
        })


        //remove the de minimus control measures from the list
        to_remove.forEach(element => {
            let index = control_measure_ids.indexOf(element)
            control_measure_ids.splice(index, 1)
        })



        // as there are multiple instances of the same control measure, we need to get the max value of the control measure id
        const sub = control_measure_ids.map(id => {

            const list = control_measure_assessments.filter(s => s.control_measure_id === id)


            const level = Math.min(...list.map(a => a.overall_assessment_id))

            return level
        })



        // now we have a list of the max values for each control measure, we need to count each category
        const rp = sub.filter(s => s === 1).length
        const rpt = sub.filter(s => s === 2).length
        const npt = sub.filter(s => s === 3).length
        const np = sub.filter(s => s === 4).length
        const undefined = sub.filter(s => s === 5).length

        countData.push([rp, rpt, npt, np, dm, undefined])

        return [name, societal_risk_value, sok, likelihood_id, harm_id, critical_hazards_societal_id, critical_hazards_individual_id, control_measures_id, cost_assessment_id, npt, rpt, rp, dm]
    })

    data.sort((a, b) => {
        return (b[1] * 1000) - (a[1] * 1000)
    })

    data.forEach(d => {
        if (d[1] === 0) {
            d[1] = 'Undefined'
        }
    })

    let csvData = [['dam name', 'societal risk', 'SoK', 'Likelihood', 'Harm', 'Societal - Critical hazards', 'Individual - critical hazards', 'control measures', 'cost assessment', 'np', 'rpt', 'rp', 'dm'], ...data]

    // with all the dams and the data we need to style each column of the table


    // state of knowledge
    let sok_column: [number, string, string][] = [[1, trafficLight.bgreen, 'Formal'], [2, trafficLight.byellow, 'Preliminary'], [3, trafficLight.bred, 'Indeterminate'], [0, trafficLight.grey, 'Undefined']]

    // likelihood

    // superscript in utf8 \u207B -
    // superscript in utf8 \u00B3 3
    // superscript in utf8 \u2074 4
    // superscript in utf8 \u2075 5

    let likelihood_column: [number, string, string][] = [
        [0, trafficLight.grey, 'Undefined'],
        [1, trafficLight.bred, 'AFP ≥ 10\u207B\u00B3'],
        [2, trafficLight.byellow, '10\u207B\u00B3 > AFP ≥ 10\u207B\u2074'],
        [3, trafficLight.bgreen, '10\u207B\u2074 > AFP ≥ 10\u207B\u2075'],
        [4, trafficLight.vgreen, 'AFP < 10\u207B\u2075']]

    //harm
    let harm_column: [number, string, string][] = [[1, trafficLight.vgreen, 'Low'], [2, trafficLight.bgreen, 'Significant'], [3, trafficLight.byellow, 'High'], [4, trafficLight.bred, 'Extreme'], [0, trafficLight.grey, 'Undefined']]

    //confidence
    let critical_hazzard_column: [number, string, string][] = [[1, trafficLight.vgreen, 'Very Strong'], [2, trafficLight.bgreen, 'Strong'], [3, trafficLight.byellow, 'Weak'], [4, trafficLight.bred, 'Very Weak'], [0, trafficLight.grey, 'Undefined'], [5, trafficLight.grey, 'Undefined']]

    // oportunity to imporve control measures

    let control_improve_column: [number, string, string][] = [[4, trafficLight.cmgreen, 'Very Weak'], [3, trafficLight.cmyellow, 'Weak'], [2, trafficLight.cmorange, 'Moderate'], [1, trafficLight.cmred, 'Strong'], [0, trafficLight.grey, 'Undefined']]


    // cost control measures
    let control_cost_column: [number, string, string][] = [[0, trafficLight.grey, 'Undefined'], [5, trafficLight.grey, 'Undefined'], [1, trafficLight.bred, 'Very Strong'], [2, trafficLight.byellow, 'Strong'], [3, trafficLight.bgreen, 'Weak'], [4, trafficLight.vgreen, 'Very Weak']]

    const order = [sok_column, likelihood_column, harm_column, critical_hazzard_column, critical_hazzard_column, control_improve_column, control_cost_column]
    const legend = ['State of Knowledge', 'Likelihood', 'Harm', 'Confidence', 'Opportunity to improve', 'Cost justification']
    const legendData = [sok_column, likelihood_column, harm_column, critical_hazzard_column, control_improve_column, control_cost_column]
    const order2: [number, string][] = [[8, 'Not Reasonably Prac. Tent.'], [9, 'Reasonably Prac. Tent.'], [10, 'Reasonably Practicable'], [11, 'De Minimis']]


    let set_colour = (value: any, index: number) => {
        let color = ""
        order[index].forEach(element => {
            if (element[0] === value) {
                color = element[1]
            }

        })
        return color
    }

    let set_text = (value: any, index: any) => {
        let description = ""
        order[index].forEach(element => {
            if (element[0] === value) {
                description = element[2]
            }
        })
        return description
    }

    let set_text2 = (index: number) => {
        let description = ""
        order2.forEach(element => {
            if (element[0] === index) {
                description = element[1]
            }
        })
        return description
    }


    return (
        <>
            <Accordion>
                <AccordionSummary id={"1"} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> Summary </Typography>
                </AccordionSummary>
                <Typography>
                    <Grid container spacing={3} xl={12} direction="row" style={{ padding: "10px" }}>
                    <Grid item xs={12}>
                                        <SummaryPie countData={countData}/>
                                    </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Paper variant={"outlined"} className={'table-section.' + ' sum-table'}>
                                <Grid container>
                                    <Grid item xs={1}></Grid>
                                    <Grid item xs={10}>
                                        <p style={{ fontSize: "20px", position: 'relative', top: '-10px' }}><strong>Portfolio summary</strong></p>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <IconButton aria-label="download" onClick={handleCaptureClick}>
                                            <GetAppIcon />
                                        </IconButton>
                                        <CSVLink data={csvData} filename={"Overall_summary.csv"}>
                                            <IconButton aria-label="download">
                                                <NotesIcon />
                                            </IconButton>
                                        </CSVLink>
                                    </Grid>
                                </Grid>

                                <div className={classes.grid}>
                                    <div></div>
                                    <div style={{ borderBottom: '1px solid grey', borderRight: '1px solid grey' }}></div>
                                    <div className={classes.heading1} style={{ gridColumn: '3/span 7', borderLeft: '0px solid grey', borderRight: '0px solid grey' }}>Matters to consider for Reasonably Practicable Assessment</div>
                                    <div className={classes.heading1} style={{ gridColumn: '10/span 4', borderRight: '1px solid grey', width: "100%" }}><span>Additional Controls Assessment<sup>7</sup></span></div>
                                    <div className={classes.heading2} style={{ borderBottom: '0px solid grey', justifyContent: 'Right', padding: '10px' }}>Dam name</div>
                                    <div className={classes.heading2} style={{ borderLeft: '0px solid grey', justifyContent: 'Right', padding: '10px' }}>Societal risk (lives/year)</div>
                                    <div className={classes.heading2} style={{ borderLeft: '0px solid grey' }}><span>State of knowledge<sup>1</sup></span></div>
                                    <div className={classes.heading2}><span>Likelihood<sup>2</sup></span></div>
                                    <div className={classes.heading2}><span>Harm<sup>3</sup></span></div>
                                    <div className={classes.heading2} style={{ gridColumn: '6/span 2', gridRow: '2/span 1' }}><span>Confidence Risk is below Threshold<sup>4</sup></span></div>
                                    <div className={classes.heading2} style={{ gridColumn: '6/span 1', gridRow: '3/span 1' }}>Societal</div>
                                    <div className={classes.heading2} style={{ gridColumn: '7/span 1', gridRow: '3/span 1' }}>Individual</div>
                                    <div className={classes.heading2}> <span>Opportunity to improve controls<sup>5</sup></span></div>
                                    <div className={classes.heading2} style={{ borderRight: '0px solid grey' }}><span>Justification based on cost effectiveness<sup>6</sup></span></div>
                                    <div className={classes.heading2} style={{ borderLeft: '1px solid grey' }}> Not Reasonably Prac. tent.</div>
                                    <div className={classes.heading2}> Reasonably Prac. tent.</div>
                                    <div className={classes.heading2}> Reasonably Practicable</div>
                                    <div className={classes.heading2} style={{ borderRight: '1px solid grey' }}> De Minimis</div>
                                    {data.map(dam => {
                                        let dam_name = dam[0]

                                        return dam.map((d, index) => {


                                            let borderLeft = ""
                                            let borderRight = "0x solid grey"

                                            if (index === 0) {
                                                return (
                                                    <div className={classes.title} >{d}</div>
                                                )
                                            }
                                            else if (index === 1) {
                                                return (
                                                    <div className={classes.item} style={{ borderLeft: "0px solid grey", borderRight: "1px solid grey" }}>{d}</div>
                                                )
                                            }
                                            else if (index > 1 && index < 9) {

                                                if (index === 2) {
                                                    borderLeft = "0px solid grey"
                                                    borderRight = "1px solid grey"
                                                }


                                                return (
                                                    <>
                                                        <LightTooltip title={
                                                            <div>
                                                                <b>{dam_name}</b> <br /> {set_text(d, index - 2)}
                                                            </div>}>
                                                            <div className={classes.item} style={{ borderLeft: borderLeft, borderRight: borderRight }}>
                                                                <div className={classes.item2} style={{ backgroundColor: set_colour(d, index - 2), color: set_colour(d, index - 2) }}>{d}</div>
                                                            </div>
                                                        </LightTooltip>
                                                    </>
                                                )
                                            }
                                            else {
                                                if (index === 9) {
                                                    borderLeft = "1px solid grey"
                                                    borderRight = "0px solid grey"
                                                }
                                                if (index === 12) {
                                                    borderRight = "1px solid grey"
                                                }
                                                return (

                                                    <LightTooltip title={
                                                        <div>
                                                            <b>{dam_name}</b> <br /> {set_text2(index - 1)}
                                                        </div>}>
                                                        <div className={classes.item} style={{ borderLeft: borderLeft, borderRight: borderRight }}><div className={classes.item2} >{d}</div></div>
                                                    </LightTooltip>)
                                            }

                                        })
                                    }
                                    )}
                                    <div className={classes.superscript} style={{ height: '15px' }}> </div>
                                    <div style={{ border: '1px lightgrey solid', gridColumn: '8 /span 6', gridRowEnd: 'span 10', marginTop: '10px' }}>
                                        <div style={{ marginTop: '5px' }}> <strong>Legend</strong> </div>
                                        {legend.map((column, index) => {
                                            let name = column
                                            let data = legendData[index]


                                            // the data comming in is a bit messy and has some formatting for the css grid
                                            // these if statements removes some of the issues and formats the data for the legend
                                            if (name === "Likelihood" || name === "Cost justification") {
                                                data.reverse()
                                            }
                                            if (name === "Confidence" || name === "Cost justification") {
                                                data.pop()
                                            }


                                            let colours = data.map(d => {
                                                return d[1]
                                            })
                                            let values = data.map(d => {
                                                return d[2]
                                            })

                                            return (
                                                <SummaryLegend name={name} values={values} colors={colours} />
                                            )
                                        })
                                        }
                                    </div>
                                    <div className={classes.superscript}><span><sup>1</sup> The overall adopted outcome for the state of knowledge</span></div>
                                    <div className={classes.superscript}><span><sup>2</sup> The sum of the annual failure probabilities for the critical grouped failure modes for each dam </span></div>
                                    <div className={classes.superscript}><span><sup>3</sup> Reports the most extreme consequence category across all critical grouped failure modes for a dam. This is taken across both Sunny Day and Flood scenarios</span></div>
                                    <div className={classes.superscript}><span><sup>4</sup> Reports the weakest confidence across all grouped failure modes for a dam</span></div>
                                    <div className={classes.superscript}><span><sup>5</sup> Reports the strongest opportunity to improve across all critical grouped failure modes for a dam</span></div>
                                    <div className={classes.superscript}><span><sup>6</sup> Reports the strongest cost-based justification across all critical grouped failure modes for a dam</span></div>
                                    <div className={classes.superscript}><span><sup>7</sup> Each control measure for a dam is only counted once. Control measures are grouped by their strongest assessment outcome, with De Minimis being the strongest outcome possible</span></div>


                                </div>

                            </Paper>
                        </Grid>
                    </Grid>
                </Typography>
            </Accordion>

        </>
    )
}


export default Summary;
